export class ConsoleManager {
    private readonly original = {
        log: console.log,
        debug: console.debug,
        info: console.info,
    }

    private static instance: ConsoleManager

    private constructor() {}

    public static getInstance(): ConsoleManager {
        if (!ConsoleManager.instance) {
            ConsoleManager.instance = new ConsoleManager()
        }
        return ConsoleManager.instance
    }

    public disableLogging() {
        console.info('[ConsoleManager] Disabling logging')

        console.log = function () {}
        console.debug = function () {}
        console.info = function () {}
    }

    public enableLogging() {
        if (console.log === this.original.log) return

        console.info('[ConsoleManager] Re-enabling logging')

        console.log = this.original.log
        console.debug = this.original.debug
        console.info = this.original.info
    }
}
